import { useQuery } from 'react-query';
import { SORT_BY_MONEY_COLLECTION, SORT_DIRECTION } from '../../../interfaces/enumerables';
import { MoneyCollectionInList } from '../../../interfaces/moneyCollection.interface';
import { GetEntities } from '../../../interfaces/shared.interface';
import { apiRQ } from '../../api';
import { queryClient } from '../../APIProvider';

const getMoneyCollectionList = async (params: {
  page: number;
  orderBy: string;
  order: string;
  search?: string;
}): Promise<GetEntities<MoneyCollectionInList>> => {
  await queryClient?.cancelQueries({ queryKey: ['useMoneyCollectionList'] });

  const resp = await apiRQ.get<GetEntities<MoneyCollectionInList>>('/money-collection', { params });

  return resp.data;
};

export const useMoneyCollectionList = (
  page: number,
  sortBy = SORT_BY_MONEY_COLLECTION.CREATED_AT,
  order = SORT_DIRECTION.ASC,
  search: string,
) => {
  return useQuery<GetEntities<MoneyCollectionInList>, Error>(
    ['useMoneyCollectionList', page, sortBy, order, search],
    () => getMoneyCollectionList({ page, orderBy: sortBy, order, search: search }),
    {
      cacheTime: 200,
      staleTime: 200,
      refetchOnWindowFocus: false,
    },
  );
};
